export function getUserOptions(users) {
	if (!users) return [];

	return users.map((entry) => ({
		value: entry.id,
		label: `${entry.name} - ${entry.username}`,
	}));
}
